import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';

export function createMissingTranslationHandler(baseTranslation: Record<string, unknown>): MissingTranslationHandler {
  return {
    handle(params: MissingTranslationHandlerParams): string {
      const key = params.key.endsWith(' *') ? params.key.substring(0, params.key.length - 2) : params.key;

      let value: unknown;
      if (Object.prototype.hasOwnProperty.call(baseTranslation, key)) {
        value = baseTranslation[key];
      } else {
        value = baseTranslation;
        for (const part of key.split('.')) {
          if (value && typeof value === 'object' && Object.prototype.hasOwnProperty.call(value, part)) {
            value = (value as Record<string, unknown>)[part];
          } else {
            return key;
          }
        }
      }

      if (typeof value !== 'string') {
        return key;
      }

      const interpolateParams = params.interpolateParams as Record<string, unknown> | undefined;
      if (interpolateParams && typeof interpolateParams === 'object') {
        return value.replace(/{{ ?(\w+) ?}}/g, (match, param) =>
          Object.prototype.hasOwnProperty.call(interpolateParams, param) ? String(interpolateParams[param]) : match,
        );
      }

      return value;
    },
  };
}
